import {
	IFetchPostDataType,
	recountTotal,
	isNullOrEmpty
} from "../commonMobile";
import { IGameType, IGameObjectType } from "@/types/GlobalTypes";

//Same as addAnimal in Shio Balls but instead this one uses number
//RaceBall number row
//Todo: copy this and make this compatible with m30
function addNumberM26(e: any): void {
	const pcode = e.currentTarget.getAttribute("pcode");
	const num = e.currentTarget.getAttribute("number");

	const games = this.state.games;
	const game = games[pcode];

	addNumberM26NotDom(game, Number(num));

	this.checkController(game); //addnumber

	this.setState({ games: games });
}

export type AddNumberNotDomType = (game: IGameType, num: number) => void;

//game: game object in state.games
//number: string
function addNumberM26NotDom(game: IGameType, num: number): void {
	const activeBetGroup = game.activeBetGroup;

	if (!activeBetGroup)
		return;

	//C3 Set or 3D Set
	const isRandom = activeBetGroup === "random";

	const maximumNumberCount = isRandom ?
		5 : 9;

	//Scans for one empty element first, then assigns the animal there
	const activeRow = game.activeUnsubmittedTicketRow;

	if (game.groupedUnsubmittedTickets[activeBetGroup].length > 0) {
		const item = game.groupedUnsubmittedTickets[activeBetGroup][activeRow];

		//Don't insert numbers when the bet is empty
		if (item.bet === 0)
			return;

		//Counts numbers in the row
		const numberCount = item.numbers.filter(_num => _num !== null).length;

		//Don't allow the same number in one ticket
		if (item.numbers.some((checkedNumber) =>
			checkedNumber === num
		)) return;

		//Move to a new row before inserting a new ball
		if (numberCount >= maximumNumberCount) {
			game.activeUnsubmittedTicketRow++;
			return;
		}

		const newInsertionRow = game.activeUnsubmittedTicketRow;
		const insertionTicket = game.groupedUnsubmittedTickets
			[activeBetGroup]
			[newInsertionRow];

		//Loops number array and inserts it into the empty slot
		for (let b = 0; b < insertionTicket.numbers.length; b++)
			if (isNullOrEmpty(insertionTicket.numbers[b])) {
				insertionTicket.numbers[b] = num;

				game.betHistory.push({
					type: "addNumberM26",
					unsubmittedTicketIdx: newInsertionRow,
					betGroup: activeBetGroup,
					numberIdx: b,
				});

				break;
			}
	}
	//End of number scanning
}



//RaceBall remove animal from unsubmitted tickets
//Similar to removeNumberM30
function removeNumberM26(e: any) {
	const pcode = e.currentTarget.getAttribute("pcode");

	const group = e.currentTarget.getAttribute("group");
	const unsubmittedTicketIdx = e.currentTarget.getAttribute("ticketindex");
	const numberIdx = e.currentTarget.getAttribute("numberindex");

	const games: IGameObjectType = this.state.games;
	const game = games[pcode];

	const num = game.groupedUnsubmittedTickets[group][unsubmittedTicketIdx].numbers[numberIdx];

	//Pushes to betHistory (for clickUndo)
	game.betHistory.push({
		type: "removeNumberM26",
		betGroup: group,
		unsubmittedTicketIdx: unsubmittedTicketIdx,
		numberIdx: numberIdx,
		number: num
	});

	//Removes the number
	game.groupedUnsubmittedTickets[group][unsubmittedTicketIdx].numbers[numberIdx] = null;

	this.checkController(game); //removeNumberM26

	this.setState({ games: games });
}

// Not Rebet
function applyM26SubmitTickets(game: IGameType, fetchPostData: IFetchPostDataType) {
	recountTotal(game);

	if (game.totalBet === 0)
		return;

	//Iterate over groups to convert into tickets
	Object.keys(game.groupedUnsubmittedTickets).forEach((group: string) => {
		//Removes unsubmitted tickets if the bet amount is 0
		//Validates empty bets and empty ticket rows
		game.groupedUnsubmittedTickets[group] = game.groupedUnsubmittedTickets[group].filter(ticket =>
			ticket.bet > 0 &&
			ticket.numbers.filter((num) => num !== null).length > 0
		);

		game.groupedUnsubmittedTickets[group].forEach(utTicket => {
			const ticketTebak = utTicket.numbers.filter(num => num !== null);
			const ticketType = group;

			//Filters ticket object for the same contents
			const filtered = game.tickets.filter(tTicket =>
				tTicket.type === group &&
				tTicket.tebak === ticketTebak.join(","));
	
			//Inserts a new ticket if there's no same ticket
			if (filtered.length === 0) {
				//Push ticket
				game.tickets.unshift({
					tebak: ticketTebak.join(","),
					taruhan: utTicket.bet,
					periode: game.periode,
					type: ticketType
				});
	
				return;
			}
	
			//Adds taruhan (bet) if there is the same ticket guess & group
			game.tickets[game.tickets.indexOf(filtered[0])]
				.taruhan += utTicket.bet;
		});
	});

	

	let totalBet = 0;

	//Applies tickets to submitted data
	game.tickets.forEach((item) => {
		fetchPostData.button_bet.push({
			button: item.tebak.split(",").filter(num => num !== "").join(","),
			group: item.type,
			value: item.taruhan
		});

		totalBet += Number(item.taruhan);
	});

	fetchPostData.total_bet = totalBet;
}

export {
	addNumberM26,
	addNumberM26NotDom,
	removeNumberM26,

	applyM26SubmitTickets,
};
